import React from "react";
import { CustomDialog } from "../../../../Components";
import { useTranslate } from "../../../../Hooks";

import useStyles from "./styles";

import { AlertCircle } from "../../../../assets/icons";

function WarningDialog({ isOpen, onClose, onConfirmAction }) {
  const styles = useStyles();
  const { translate } = useTranslate("AgentCommissionView");

  return (
    <CustomDialog
      paperClassName={styles.dialogWrapper}
      open={isOpen}
      onClose={() => {
        onClose(false);
      }}
      onConfirm={() => {
        onConfirmAction();
        onClose(true);
      }}
      headingIcon={
        <div className={styles.modalIcon}>
          <AlertCircle width="20" height="20" fill={"#D92D20"} />
        </div>
      }
      title={translate("unsaved-changes-modal-title")}
      subtitle={translate("unsaved-changes-modal-content")}
      cancelText={translate("continue-not-saving")}
      confirmText={translate("save-changes")}
      hideActionsBorder
    />
  );
}

export default WarningDialog;
